import React, { useEffect, useState } from "react";
import { StickyContainer, Sticky } from "react-sticky";
import { styled } from "../../stitches.config";
import Title from "../atoms/Title";
import Columnist from "../components/Columnist";
import RecruitmentBox from "../components/RecruitmentBox";
import parse from "html-react-parser";
import truncate from "../../helpers/truncate";
import Button from "../atoms/Button";
import Link from "../../components/Link";
import Breadcrumbs from "../components/Breadcrumbs";
import ZenBox from "../components/ZenBox";
import Footer from "../components/Footer"

interface IBlog {
  about: string;
  link: string;
  name: string;
  picture: string;
}

const BlogsPage = () => {
  const [blogs, setBlogs] = useState<IBlog[]>([]);
  const [pageCount, setPageCount] = useState(10);

  useEffect(() => {
    const fetchUrl = `${window.API_HOST}/pwa-blogs/`;

    fetch(fetchUrl)
      .then((response) => {
        return response.ok ? response.json() : Promise.reject(response.status);
      })
      .then((response) => {
        setBlogs(response.blogs);
      });
  }, []);

  return (
    <>
      <Container>
        <Breadcrumbs category={{ name: "Stefa blogów", link: "" }} invert />
        <Title withDots size="large" type="transparent">
          Strefa blogów
        </Title>
        <Wrapper>
          <StyledColumnists>
            <StyledColumnistsWrapper className='blogers__list'>
              {blogs.map((blog, index) => {
                if (index >= pageCount) return null;
                return index === 3 ? (
                  <>
                    <OnlyMobile>
                      <RecruitmentBox
                        title="Zacznij pisać dla na:Temat"
                        description="Chcesz tworzyć swojego bloga w ramach portalu na:Temat?"
                        link="blogi@natemat.pl"
                        backgroundColor="grayscale10"
                      />
                    </OnlyMobile>

                    <Link to={blog.link}>
                      <Columnist
                        type="default"
                        name={blog.name}
                        url={blog.link}
                        src={blog.picture}
                        title={parse(truncate(blog.about, 130)) as string}
                      />
                    </Link>
                  </>
                ) : (
                  <Link to={blog.link}>
                    <Columnist
                      type="default"
                      name={blog.name}
                      url={blog.link}
                      src={blog.picture}
                      title={parse(truncate(blog.about, 130)) as string}
                    />
                  </Link>
                );
              })}
            </StyledColumnistsWrapper>
            {blogs.length > pageCount && (
              <ButtonWrapper>
                <Button
                  text="Pokaż więcej"
                  starPosition="none"
                  onClick={() => setPageCount((prev) => prev + 10)}
                ></Button>
              </ButtonWrapper>
            )}
          </StyledColumnists>
          <SideSection>
            <StickyContainer style={{ height: "100%" }}>
              <Sticky topOffset={-91} style={{ height: "100%" }}>
                {({ style, isSticky }) => (
                  <StickyWrap isSticky={isSticky} style={style}>
                    <RecruitmentBox
                      title="Zacznij pisać dla na:Temat"
                      description="Chcesz tworzyć swojego bloga w ramach portalu na:Temat?"
                      link="blogi@natemat.pl"
                      backgroundColor="grayscale10"
                    />
                  </StickyWrap>
                )}
              </Sticky>
            </StickyContainer>
          </SideSection>
        </Wrapper>
      </Container>
      <Footer />
    </>
  );
};

export default BlogsPage;

const OnlyMobile = styled("div", {
  "@bp4": {
    display: "none",
  },
});

const Wrapper = styled("div", {
  "@bp4": {
    display: "grid",
    gridTemplateColumns: "3.8fr 1fr",
    gap: "24px",
  },
});

const StickyWrap = styled("div", {
  variants: {
    isSticky: {
      true: {
        paddingTop: "91px",
      },
      false: {}
    }
  }
});

const SideSection = styled("div", {
  display: "none",
  height: "100%",
  "@bp4": {
    display: "block",
    alignSelf: "flex-start",
    paddingTop: "5px",
  },
});

const StyledColumnists = styled("div", {
  width: "100%",
});

const StyledColumnistsWrapper = styled("div", {
  width: "100%",
  display: "flex",
  flexDirection: "column",
  gap: "16px",
  a: {
    textDecoration: "none",
  },
  "& .columnist": {
    justifyContent: "flex-start",
  },
  "@bp4": {
    flexWrap: "wrap",
    flexDirection: "row",
    gap: "24px",
  },
});

const Container = styled("div", {
  backgroundColor: "$grayscale10",
  padding: "34px 16px 36px 16px",
  "@bp4": {
    padding: "50px 84px 78px 84px",
  },
});

const ButtonWrapper = styled("div", {
  margin: "40px auto",
  display: "flex",
  justifyContent: "center",
});
